import React, {useContext} from "react";
import Context from "../../context/Message";

export default ({hasMore, loading, onClick}) => {
    const {$locale} = useContext(Context);

    if (!hasMore) {
        return null;
    }

    const Container = ({children}) => (
        <div className="tac load-more">{children}</div>
    );

    if (loading) {
        return (
            <Container><a className="link-button" disabled>{$locale.get('message.loadingMore')}</a></Container>
        );
    }

    return (
        <Container><a className="link-button" onClick={onClick}>{$locale.get('message.loadMore')}</a></Container>
    );
}
